import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://myzlynapgbagolvtvgth.supabase.co";
const supabaseAnonKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im15emx5bmFwZ2JhZ29sdnR2Z3RoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjAyMDEzMjUsImV4cCI6MjA3NTc3NzMyNX0.NkNpDJK1Q_F4UoRiVFNHbhlEPLCduPC6m8-Kuaph5AE";

// ✅ generate a unique tab id (per tab) so each tab has its own auth storageKey
const TAB_ID_KEY = "reignite.tab_id";
let tabId = sessionStorage.getItem(TAB_ID_KEY);

if (!tabId) {
  tabId = crypto?.randomUUID?.() || `${Date.now()}-${Math.random()}`;
  sessionStorage.setItem(TAB_ID_KEY, tabId);
}

// ✅ per-tab storageKey (THIS must be top-level)
const storageKey = `reignite.session.${tabId}`;

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    storage: window.sessionStorage, // ✅ per-tab
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
  global: {
    headers: { "x-client-info": "reignite-spirit" },
  },
  // ✅ IMPORTANT: this is where storageKey belongs
  storageKey,
});